import { Col, Row, Space, Spin } from "antd";
import GweLayout from "../../components/gweLayout/gweLayout";
import { AddCardForm, SettlementClientCard } from "../settlement/clientSettlementList";
import { useParams } from "react-router-dom";
import { useInjection } from "inversify-react";
import ApiService from "../../services/apiService";
import { useCallback, useEffect, useState } from "react";
import { CheckoutApi, ClientPaymentStatus, SettlementClientDto } from "../../api";
import { useQueryParams } from "../../hooks/useQueryParams";
import { useAuth } from "oidc-react";

export default function Checkout() {
    const { guid } = useParams();
    const apiService = useInjection(ApiService);
    const [settlement, setSettlement] = useState<SettlementClientDto>();
    const [isSaved, setIsSaved] = useState(false);
    const auth = useAuth();

    const { searchParams } = useQueryParams();

    const getSettlement = useCallback(async () => {
        const response = await apiService.getApi(CheckoutApi).apiCheckoutGet(guid);

        setSettlement(response.data!);
    }, [guid]);

    const onSaved = useCallback(async () => {
        await apiService.getApi(CheckoutApi).apiCheckoutPayPost(guid);
        setIsSaved(true);

        let tries = 0;

        setInterval(async () => {
            await getSettlement();
            tries++;

            if (tries > 9) {
                window.location.href = "https://gwexperts.pl/warning";
            }
        }, 1000);
    }, [guid]);

    useEffect(() => {
        if (searchParams.get('statusCode') === "SUCCESS" && settlement && !isSaved) {
            onSaved();
            console.log("pay use effect");
        }
    }, [searchParams, settlement, isSaved]);

    useEffect(() => {
        getSettlement();
    }, [getSettlement]);

    useEffect(() => {
        const logout = async () => {
            await auth.userManager.clearStaleState();
            await auth.signOut();
            await auth.userManager.signoutPopup();
            window.location.reload();
        }
        
        if (auth.userData) {
            logout();
        }
    }, [auth.userData]);

    useEffect(() => {
        if (settlement?.paymentStatus === ClientPaymentStatus.Paid) {
            window.location.href = "https://gwexperts.pl/success";

            fbq('track', 'Purchase', {value: settlement.grossAmount, currency: 'PLN'});
        }
    }, [settlement]);

    const saveCardRequest = (t: string, f: string) => {
        fbq("track", "AddPaymentInfo");
        
        return apiService.getApi(CheckoutApi).apiCheckoutSaveCardPost({ token: t, fingerprint: f, settlementId: guid })
    };

    return <GweLayout title="Płatność">
        <Row justify="center">
            <Col xs={24} md={12} lg={14} xl={16}>
                {(settlement && !isSaved) && <SettlementClientCard settlement={settlement} />}
                {(settlement && isSaved) && <Spin><SettlementClientCard settlement={settlement} /></Spin>}
                {!isSaved && <AddCardForm onSaved={onSaved} saveCardRequest={saveCardRequest} />}
            </Col>
        </Row>
    </GweLayout>
}